// extracted by mini-css-extract-plugin
export default {"AssessmentTension":"AssessmentTension_AssessmentTension__qvYwb","title":"AssessmentTension_title__UgZq-","content":"AssessmentTension_content__0wE8J"};